import React from 'react';
import { HeroSection } from '@/components/sections/HeroSection';
import { CountdownBanner } from '@/components/sections/CountdownBanner';
import { AnnouncementsSection } from '@/components/sections/AnnouncementsSection';
import { RsvpSection } from '@/components/sections/RsvpSection';
import { VenueImageSection } from '@/components/sections/VenueImageSection';
import { ScheduleSection } from '@/components/sections/ScheduleSection';
import { StreetMapSection } from '@/components/sections/StreetMapSection';
import { TravelSection } from '@/components/sections/TravelSection';
import { AccommodationSection } from '@/components/sections/AccommodationSection';
import { FaqSection } from '@/components/sections/FaqSection';

export const Home: React.FC = () => {
    return (
        <>
            <HeroSection />
            <CountdownBanner />
            <VenueImageSection />
            <ScheduleSection />
            <StreetMapSection />
            <TravelSection />
            <AccommodationSection />
            <FaqSection />
            <AnnouncementsSection />
            <RsvpSection />
        </>
    );
};
